const HomeBannerSvg = (props: any) => {
  return (
    <svg
      width="276"
      height="150"
      viewBox="0 0 276 289"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="138" cy="138" r="138" fill="url(#paint0_linear_15_119)" />
      <g clipPath="url(#clip0_15_119)">
        <path
          d="M43.8965 289H39.6945L48.6496 211.476H52.8516L43.8965 289Z"
          fill="#0E2E35"
        />
        <path
          d="M91.3279 289H95.5298L86.5729 211.476H82.3727L91.3279 289Z"
          fill="#0E2E35"
        />
        <path
          d="M117.429 289H113.227L122.182 211.476H126.384L117.429 289Z"
          fill="#0E2E35"
        />
        <path
          d="M164.861 289H169.061L160.106 211.476H155.904L164.861 289Z"
          fill="#0E2E35"
        />
        <path
          d="M114.25 219.9H56.9426C50.2253 219.9 44.2238 214.477 43.5358 207.787L34.0647 115.656C33.3767 108.965 38.2649 103.542 44.9821 103.542H102.29C109.007 103.542 115.008 108.965 115.696 115.656L125.167 207.788C125.854 214.477 120.967 219.9 114.25 219.9Z"
          fill="#E25A44"
        />
        <path
          d="M130.163 219.9H72.8554C66.1381 219.9 60.1366 214.477 59.4486 207.787L49.9775 115.656C49.2895 108.965 54.1777 103.542 60.8949 103.542H118.202C124.92 103.542 130.921 108.965 131.609 115.656L141.08 207.788C141.768 214.477 136.88 219.9 130.163 219.9Z"
          fill="#F47458"
        />
        <path
          d="M137.842 224.148H56.6134C50.3197 224.148 44.6936 219.065 44.05 212.797C43.4064 206.529 47.9856 201.446 54.2794 201.446H135.508C141.802 201.446 147.428 206.529 148.071 212.797C148.717 219.067 144.137 224.148 137.842 224.148Z"
          fill="#E25A44"
        />
        <path
          d="M158.121 224.148H76.8928C70.5991 224.148 64.973 219.065 64.3294 212.797C63.6858 206.529 68.265 201.446 74.5588 201.446H155.787C162.081 201.446 167.707 206.529 168.351 212.797C168.996 219.067 164.415 224.148 158.121 224.148Z"
          fill="#F47458"
        />
        <path
          d="M127.866 135.785L133.209 150.529C133.209 150.529 119.965 153.854 119.63 153.964C119.295 154.075 116.403 139.444 116.403 139.444L127.866 135.785Z"
          fill="#AD5A3B"
        />
        <path
          d="M144.184 257.914C144.184 257.914 134.417 269.579 134.352 270.593C134.287 271.608 134.74 282.686 135.902 283.7C137.063 284.715 140.476 285.436 139.379 286.578C138.55 287.44 132.171 287.256 127.944 287.023C126.71 286.955 125.162 277.148 124.674 275.708C123.963 273.614 122.238 268.9 122.883 267.441C123.198 266.73 124.701 265.269 126.823 263.906C129.053 262.471 137.581 250.653 137.581 250.653L144.184 257.914Z"
          fill="#AD5A3B"
        />
        <path
          d="M126.958 263.834C126.958 263.834 133.516 282.227 136.083 283.115C136.765 283.35 140.035 283.949 140.653 285.39C140.838 285.824 140.653 287.274 140.653 287.274H126.982C126.982 287.274 125.253 279.171 124.57 275.61C124.57 275.61 120.951 266.91 121.354 266.12C121.755 265.328 126.958 263.834 126.958 263.834Z"
          fill="#14424D"
        />
        <path
          d="M202.61 263.331C202.61 263.331 210.587 274.516 209.884 278.053C209.509 279.948 207.835 282.428 208.795 284.211C209.755 285.994 210.851 286.44 210.851 286.44L235.732 286.837C237.088 286.86 236.193 285.992 235.1 285.194C233.311 283.886 231.867 283.023 226.154 280.276C225.782 280.097 224.425 279.239 223.934 278.942C222.693 278.189 221.449 277.005 220.376 275.817C218.589 273.84 210.733 257.73 210.733 257.73L202.61 263.331Z"
          fill="#AD5A3B"
        />
        <path
          d="M173.76 194.332C173.76 194.332 163.884 205.56 161.365 207.339C158.846 209.117 134.672 253.456 134.672 253.456L143.285 259.719C143.285 259.719 164.89 232.886 175.038 218.535C183.618 206.4 180.457 207.17 185.503 199.783C188.28 195.716 187.65 190.217 183.988 186.918C183.533 186.508 183.037 186.08 182.499 185.633C175.031 179.432 123.84 172.456 123.84 172.456L91.0966 175.651C91.0966 175.651 117.849 194.334 118.846 194.832C119.845 195.329 155.789 200.549 156.538 200.549C157.285 200.549 173.76 194.332 173.76 194.332Z"
          fill="#6292DE"
        />
        <path
          d="M87.7676 175.936C87.7676 175.936 82.1508 192.717 90.5751 200.549C98.9994 208.38 149.048 207.51 165.523 207.51C165.523 207.51 172.262 225.909 173.011 228.891C173.76 231.875 206.459 270.408 206.459 270.408L215.445 264.691C215.445 264.691 180.25 196.571 177.504 193.588C174.757 190.604 135.569 178.671 125.833 175.936C116.1 173.201 87.7676 175.936 87.7676 175.936Z"
          fill="#86B1F2"
        />
        <path
          d="M125.262 77.3229C125.14 64.9887 115.426 54.747 103.118 58.9652C100.35 59.9139 96.4749 62.0875 94.3665 64.11C88.6665 69.5772 86.3399 77.0042 80.5067 82.2706C82.1342 83.9119 84.1372 85.6747 86.5673 87.4393L90.257 83.7682L88.452 88.749C95.6205 93.5162 106.055 98.0955 120.936 100.131C124.008 92.015 125.327 83.9026 125.262 77.3229Z"
          fill="#133742"
        />
        <path
          d="M125.149 121.39C119.012 102.852 112.151 103.642 112.151 103.642L117.457 142.616C121.247 141.584 126.179 139.287 129.965 138.222C128.711 132.363 126.66 125.956 125.149 121.39Z"
          fill="#D9D9D9"
        />
        <path
          d="M96.449 100.313C96.449 100.313 85.1432 99.5949 80.6712 104.46C76.2011 109.328 90.5936 147.821 91.4074 154.014C92.2211 160.207 87.2627 176.675 87.2627 176.675C87.2627 176.675 113.819 182.009 121.409 176.995C121.409 176.995 122.223 132.46 121.409 128.036C120.596 123.611 113.819 105.62 112.193 103.852C110.564 102.084 96.449 100.313 96.449 100.313Z"
          fill="white"
        />
        <path
          d="M99.7429 166.96C97.0113 165.409 90.4142 164.097 90.4142 164.097C81.4758 185.303 84.4368 203.655 95.3467 206.269C106.257 208.883 116.801 209.988 154.591 208.514C164.702 185.305 175.525 182.494 175.525 182.494C157.798 173.392 99.7429 166.96 99.7429 166.96Z"
          fill="white"
        />
        <path
          d="M100.213 85.2344C100.213 85.2344 100.153 85.566 100.05 86.1315C99.545 88.8448 97.6049 97.845 96.2936 100.319C94.7087 103.308 101.718 112.846 108.465 111.682C110.473 111.336 106.767 102.92 106.945 102.028C107.285 100.323 107.747 97.9942 108.221 95.6069C108.487 94.2604 108.757 92.8955 109.012 91.6116C109.734 87.9643 110.322 84.9821 110.322 84.9821L100.213 85.2344Z"
          fill="#AD5A3B"
        />
        <path
          d="M100.05 86.1315C100.155 85.566 100.213 85.2344 100.213 85.2344L110.322 84.9821C110.322 84.9821 109.734 87.9643 109.012 91.6116C108.759 92.8881 108.491 94.2457 108.226 95.5848C106.665 95.3546 105.034 94.5975 103.399 93.1699C101.616 91.6116 100.448 89.7401 99.7429 87.7415C99.8668 87.1023 99.9722 86.5533 100.05 86.1315Z"
          fill="#8C4326"
        />
        <path
          d="M110.749 64.25C110.749 64.25 106.111 63.0324 102.604 66.4273C99.0974 69.8222 94.213 81.1728 100.632 88.6404C107.054 96.108 115.356 89.8782 117.54 82.3296C119.728 74.7791 121.489 65.4989 110.749 64.25Z"
          fill="#AD5A3B"
        />
        <path
          d="M119.732 82.5248C118.611 84.1016 117.004 84.8329 116.142 84.1587C115.28 83.4863 115.493 81.6627 116.614 80.0859C117.734 78.5092 119.342 77.7779 120.204 78.4502C121.065 79.1244 120.855 80.948 119.732 82.5248Z"
          fill="#AD5A3B"
        />
        <path
          d="M111.459 63.0637C111.459 63.0637 103.542 73.3902 98.9587 73.2649C94.3758 73.1397 92.9258 79.0213 92.9258 79.0213C92.9258 79.0213 96.5156 65.5063 101.359 63.4929C106.205 61.4777 111.459 63.0637 111.459 63.0637Z"
          fill="#133742"
        />
        <path
          d="M167.866 123.889H131.513C130.594 123.889 129.612 124.632 129.32 125.547L113.991 173.663C113.699 174.578 114.208 175.321 115.129 175.321H151.482C152.401 175.321 153.383 174.578 153.675 173.663L169.005 125.547C169.294 124.632 168.785 123.889 167.866 123.889Z"
          fill="#14424D"
        />
        <path
          d="M99.7355 76.2545C99.815 78.301 98.8145 80.0233 97.5013 80.1025C96.1882 80.1817 95.0582 78.5884 94.9787 76.5419C94.8991 74.4954 95.8997 72.7731 97.2128 72.6939C98.5259 72.6147 99.656 74.208 99.7355 76.2545Z"
          fill="#AD5A3B"
        />
        <path
          d="M128.304 159.067C128.066 158.848 128.108 158.704 128.108 158.704C128.484 158.3 128.534 156.696 128.03 156.304C127.526 155.911 124.805 155.464 124.566 155.287C124.328 155.11 123.923 154.736 123.529 154.666C123.137 154.596 120.387 153.169 119.832 153.071C119.275 152.973 117.355 153.708 116.218 153.845C115.081 153.979 113.277 155.005 112.761 155.25C112.377 155.432 104.903 154.235 102.972 153.95C100.877 153.64 99.2694 153.274 99.2694 153.274C99.2694 153.274 87.1037 150.114 74.322 147.768L77.7787 137.452L65.7812 134.732C64.3016 140.635 61.1187 149.702 60.7118 152.522C59.911 158.068 79.0345 159.573 95.9885 160.632C97.8528 160.749 99.6116 160.848 101.219 160.935C103.397 161.134 107.015 161.762 108.683 162.04C109.721 162.305 111.143 162.679 111.313 162.793C111.585 162.976 113.473 163.545 113.638 163.574C113.801 163.604 114.429 164.051 114.701 164.234C114.973 164.416 118.824 164.963 119.445 165.074C120.067 165.184 121.489 164.965 121.489 164.965L124.076 165.221C125.976 165.409 125.552 163.423 125.552 163.423C126.449 163.506 126.932 163.213 127.121 162.718C127.311 162.222 127.189 161.62 127.231 161.528C127.274 161.434 127.557 161.408 127.557 161.408C128.125 161.483 128.591 160.861 128.691 160.448C128.789 160.034 128.543 159.284 128.304 159.067Z"
          fill="#AD5A3B"
        />
        <path
          d="M64.5938 134.728C64.5938 134.728 70.3494 112.073 74.8769 106.335C79.4044 100.597 90.2737 99.1436 94.1557 104.316C98.0377 109.49 79.8871 138.296 79.8871 138.296L64.5938 134.728Z"
          fill="white"
        />
        <path
          d="M144.274 139.331C143.897 140.764 144.544 142.175 145.719 142.481C146.893 142.787 148.151 141.873 148.528 140.44C148.905 139.007 148.258 137.596 147.084 137.29C145.909 136.984 144.652 137.898 144.274 139.331Z"
          fill="white"
        />
        <path
          d="M225.599 279.574C218.04 281.501 212.451 280.191 209.325 278.939C208.519 281.21 207.45 284.058 208.018 285.701C208.711 287.712 209.699 288.167 210.572 288.19C217.476 288.37 235.863 288.615 241.129 288.683C241.865 288.692 242.27 287.84 241.797 287.278C240.491 285.729 226.161 279.917 225.599 279.574Z"
          fill="#14424D"
        />
        <path
          d="M109.819 86.5736L104.089 84.5474C104.089 84.5474 103.449 86.7615 105.942 87.7249C108.983 88.9001 109.819 86.5736 109.819 86.5736Z"
          fill="white"
        />
        <path
          d="M157.979 164.864C158.432 163.968 158.787 161.664 159.031 160.883C159.153 160.491 159.309 159.958 159.418 159.463C159.558 158.833 159.212 158.194 158.609 157.956C157.777 157.626 156.644 157.16 156.25 157.182C155.637 157.215 154.792 158.505 154.866 159.028C154.866 159.028 154.82 159.164 154.511 159.207C154.202 159.247 153.596 159.702 153.448 160.08C153.298 160.457 153.322 161.202 153.81 161.454C153.81 161.454 154.019 161.629 154.001 161.725C153.982 161.821 153.557 162.228 153.433 162.721C153.309 163.215 153.527 163.709 154.278 164.134C154.278 164.134 152.852 165.464 154.45 166.356L155.182 166.765C155.943 167.188 156.906 166.906 157.313 166.138C157.559 165.672 157.809 165.197 157.979 164.864Z"
          fill="#AD5A3B"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_15_119"
          x1="138"
          y1="0"
          x2="138"
          y2="276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FFFC7" />
          <stop offset="1" stopColor="#017849" />
        </linearGradient>
        <clipPath id="clip0_15_119">
          <rect
            width="208"
            height="231"
            fill="white"
            transform="translate(34 58)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HomeBannerSvg
